<template>
    <div v-if="store">
        <h1>Nytt objekt i {{ store.name }}</h1>

        <p>
            <router-link :to="`/store/${store.id}`" class="button">Tillbaka</router-link>
        </p>

        <SalesItemForm :salesItem="salesItem" @submit="submit"/>
    </div>
    <p v-else class="app-loader">
        Laddar...
    </p>
</template>

<script>
import SalesItemForm from '../components/SalesItemForm.vue'

export default {
    name: 'salesItemNew',
    components: {
        SalesItemForm
    },
    data: function () {
        return {
            salesItem: {
                name: '',
                description: ''
            },
            storeId: null
        }
    },
    computed: {
        store() {
            return this.$store.getters['traderaStores/getById'](this.storeId);
        }
    },
    methods: {
        submit() {
            this.$store.dispatch('salesItems/create', this.salesItem)
                .then(response => {
                    this.$router.push(`/store/${this.storeId}/sales_item/${response.data.id}`);
                })
            ;
        }
    },
    created() {
        this.$store.dispatch('traderaStores/getAll');
        this.storeId = parseInt(this.$route.params.id, 10);
    },
    watch: {
        '$route'(to) {
            this.storeId = parseInt(to.params.id, 10);
        }
    }
}
</script>
